import { Product, SaleItem } from '@tendercuts/models';
import { Injectable, Pipe, PipeTransform } from '@angular/core';

/*
  Generated class for the Weight pipe.

  See https://angular.io/docs/ts/latest/guide/pipes.html for more info on
  Angular 2 Pipes.
*/
@Pipe({
  name: 'weight',
  pure: false
})
@Injectable()
export class WeightPipe implements PipeTransform {

  public UOM = {
    GMS: 72,
    KG: 73,
    PACK: 74,
    UNIT: 75
  };
  // used during product display
  transformProduct(product: Product) {
    if (product.weight_from == 1000 && product.weight_to == 1000) {
      return ' 1 Pack';
    } else {
      return `${product.weight_from} - ${product.weight_to}gms`;
    }

  }

  // used in shopping cart
  transformSaleItem(item: SaleItem) {

    function formatString(value) {
      if (isNaN(+value)) {
        return "";
      }

      let data = "";
      const total = item.quantity * +value;

      if (total < 1000) {
        data = `${total} gms`
      } else {
        data = `${total / 1000} Kg`
      }

      return data;
    }

    if (item.product.weight_from == 1000 && item.product.weight_to == 1000) {
      return `${item.quantity} x 1 Pack`;
    } else {
      return `${formatString(item.product.weight_from)} - ${formatString(item.product.weight_to)}`;
    }
  }

  transform(value, args) {
    if (value instanceof Product) {
      return this.transformProduct(value);
    }

    if (value instanceof SaleItem) {
      return this.transformSaleItem(value);
    }

  }
}
